<template>
  <Layout>
    <div class="banner-page">
      <img src="/img/faq-banner.png" alt="Image" />
    </div>

    <div class="breadcrumbs">
      <div class="container">
        <ul>
          <li>
            <a href="/">Beranda</a>
          </li>
          <li>
            <span>F.A.Q</span>
          </li>
        </ul>
      </div>
    </div>

    <section class="page-section covid-section">
      <div class="container">
        <div class="section-title text-center">F.A.Q</div>
        <div class="text-center mb-32">
          Topik yang sering dicari ini dapat memudahkan anda dalam penggunaan
          masjed.id
        </div>
        <div class="accordion" id="faq">
          <div class="accordion-item accordion-laknat">
            <h2 class="accordion-header" id="faqHeading1">
              <div
                class="accordion-basic "
                aria-expanded="true"
                aria-controls="panelFaq1"
              >
                Apa itu Aplikasi Masjed ?
              </div>
            </h2>
            <div
              id="panelFaq1"
              class="accordion-collapse"
              aria-labelledby="faqHeading1"
            >
              <div class="accordion-body-ext">
                <p>
                  Masjed adalah aplikasi ekosistem masjed ‘Single Device Multi Platform and Multi User’ yang dilengkapi dengan feature-feature yang bermanfaat berbasis masjed sebagai 
                </p>
              </div>
            </div>
          </div>
          <div class="accordion-item accordion-laknat">
            <h2 class="accordion-header" id="faqHeading2">
              <div
                class="accordion-basic "
                aria-expanded="true"
                aria-controls="panelFaq1"
              >
                Handphone apa yang bisa digunakan untuk mengakses Aplikasi Masjed ?
              </div>
            </h2>
            <div
              id="panelFaq2"
              class="accordion-collapse "
              aria-labelledby="faqHeading2"
            >
              <div class="accordion-body-ext">
                <p>
                Aplikasi Masjed dapat diakses dari semua merk handphone dengan sistem operasi 
                pusat perkembangan peradaban untuk kemaslahatan dan keberkahan menuju kemakmuran dunia dan akhirat 
                yang berkeadilan sosial meraih Rahmatan Lil-alamin.  berbasis Android minimal OS IceCream dan sistem operasi 
                berbasis IOS minimal Versi 9
                </p>
              </div>
            </div>
          </div>
          <div class="accordion-item accordion-laknat">
            <h2 class="accordion-header" id="faqHeading3">
              <div
                class="accordion-basic "
                aria-expanded="true"
                aria-controls="panelFaq1"
              >
                Bagaimana cara mendapatkan Aplikasi Masjed ?
              </div>
            </h2>
            <div
              id="panelFaq3"
              class="accordion-collapse"
              aria-labelledby="faqHeading3"
            >
              <div class="accordion-body-ext">
                <p>
                  Silahkan unduh Aplikasi Masjed melalui Google Playstore dan Appstore
                </p>
              </div>
            </div>
          </div>
          <div class="accordion-item accordion-laknat">
            <h2 class="accordion-header" id="faqHeading4">
              <div
                class="accordion-basic "
                aria-expanded="true"
                aria-controls="panelFaq1"
              >
                Bagaimana cara registrasi untuk penggunaan Aplikasi Masjed ?
              </div>
            </h2>
            <div
              id="panelFaq4"
              class="accordion-collapse"
              aria-labelledby="faqHeading4"
            >
              <div class="accordion-body-ext">
                <p>
                  Buka Aplikasi Masjed > Klik Daftarkan Sekarang > Masukan Nomor Handphone Anda > Lalu masukan Kode OTP yang dikirimkan melalui WhatsApp Anda 
                </p>
              </div>
            </div>
          </div>
          <div class="accordion-item accordion-laknat">
            <h2 class="accordion-header" id="faqHeading4">
              <div
                class="accordion-basic "
                aria-expanded="true"
                aria-controls="panelFaq1"
              >
                Fitur apa saja yang terdapat di Aplikasi Masjed ?
              </div>
            </h2>
            <div
              id="panelFaq4"
              class="accordion-collapse"
              aria-labelledby="faqHeading4"
            >
              <div class="accordion-body-ext">
                <p>
                  Kegiatan yang memudahkan pengguna aplikasi masjed dalam melakukan ibadah, 
                  melakukan transaksi pembayaran tagihan ataupun transaksi pembelian, melakukan Zakat, Infaq, Sedekah dan Wakaf 
                  serta melakukan Donasi Kemanusiaan
                </p>
              </div>
            </div>
          </div>
          <div class="accordion-item accordion-laknat">
            <h2 class="accordion-header" id="faqHeading4">
              <div
                class="accordion-basic "
                aria-expanded="true"
                aria-controls="panelFaq1"
              >
                Dimanakah saya bisa melihat riwayat transaksi yang sudah dilakukan ?
              </div>
            </h2>
            <div
              id="panelFaq4"
              class="accordion-collapse"
              aria-labelledby="faqHeading4"
            >
              <div class="accordion-body-ext">
                <p>
                  Silahkan buka Aplikasi Masjed > Klik Menu Riwayat yang terdapat di bagian bawah Aplikasi Masjed
                </p>
              </div>
            </div>
          </div>
          <div class="accordion-item accordion-laknat">
            <h2 class="accordion-header" id="faqHeading4">
              <div
                class="accordion-basic "
                aria-expanded="true"
                aria-controls="panelFaq1"
              >
                Bagaimana cara melaporkan jika ada permasalahan di akun Masjed ?
              </div>
            </h2>
            <div
              id="panelFaq4"
              class="accordion-collapse"
              aria-labelledby="faqHeading4"
            >
              <div class="accordion-body-ext">
                <p>
                  Silahkan klik icon Whatsapp yang berada di kiri bawah Beranda Aplikasi Masjed
                </p>
              </div>
            </div>
          </div>
          <div class="accordion-item accordion-laknat">
            <h2 class="accordion-header" id="faqHeading4">
              <div
                class="accordion-basic "
                aria-expanded="true"
                aria-controls="panelFaq1"
              >
              Bagaimana cara menemukan Masjed terdekat dari Aplikasi Masjed ?
              </div>
            </h2>
            <div
              id="panelFaq4"
              class="accordion-collapse"
              aria-labelledby="faqHeading4"
            >
              <div class="accordion-body-ext">
                <p>
                  Silahkan klik icon ‘Cari Masjed’ yang berada di bagian tengah bawah aplikasi Masjed > Klik di bagian search > Masukan Nama Masjed yang ingin anda cari
                </p>
              </div>
            </div>
          </div>
          <div class="accordion-item accordion-laknat">
            <h2 class="accordion-header" id="faqHeading4">
              <div
                class="accordion-basic "
                aria-expanded="true"
                aria-controls="panelFaq1"
              >
                Bagaimana cara berdonasi ke Masjed pilihan sendiri ?
              </div>
            </h2>
            <div
              id="panelFaq4"
              class="accordion-collapse"
              aria-labelledby="faqHeading4"
            >
              <div class="accordion-body-ext">
                <p>
                  Silahkan klik icon ‘Cari Masjed’ yang berada di bagian tengah bawah aplikasi Masjed > Klik di bagian search > Masukan Nama Masjed yang ingin anda cari > Klik Infaq > Masukan nominal donasi anda > klik pembayaran > selesai
                </p>
              </div>
            </div>
          </div>
          <div class="accordion-item accordion-laknat">
            <h2 class="accordion-header" id="faqHeading4">
              <div
                class="accordion-basic "
                aria-expanded="true"
                aria-controls="panelFaq1"
              >
                Bagaimana cara merubah akun di Aplikasi Masjed ?
              </div>
            </h2>
            <div
              id="panelFaq4"
              class="accordion-collapse"
              aria-labelledby="faqHeading4"
            >
              <div class="accordion-body-ext">
                <p>
                Silahkan klik Profil di bagian kanan bawah aplikasi Masjed > Klik Upgrade > Silahkan pilih upgrade user yang anda inginkan > silahkan lengkapi biodata anda sesuai dengan user yang ingin anda upgrade
                </p>
              </div>
            </div>
          </div>
          <div class="accordion-item accordion-laknat">
            <h2 class="accordion-header" id="faqHeading4">
              <div
                class="accordion-basic "
                aria-expanded="true"
                aria-controls="panelFaq1"
              >
                Dimana kontak resmi yang dapat dihubungi oleh pengguna Aplikasi Masjed ?
              </div>
            </h2>
            <div
              id="panelFaq4"
              class="accordion-collapse"
              aria-labelledby="faqHeading4"
            >
              <div class="accordion-body-ext">
                <p>
                  WhatsApp	: 081211300567 <br>
                  Email		: marbot@masjed.id 	 
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="row mt-32">
                    <div class="col-md-10 offset-md-1">
                        <div class="row">
                            <div class="col-md-6">
                                <a href="#" class="btn btn-main btn-block mb-8">Konsultasi dengan Dokter</a>
                            </div>
                            <div class="col-md-6">
                                <a href="#" class="btn btn-main btn-block mb-8">Permohonan Vitamin / Obat</a>
                            </div>
                        </div>
                    </div>
                </div> -->
      </div>
    </section>
  </Layout>
</template>

<script>
import Layout from '../views/layouts/Index.vue';

import { mapActions } from 'vuex';

export default {
  components: {
    Layout,
  },
  methods: {
    ...mapActions('transactions', ['resetForm']),
  },
  mounted() {
    this.resetForm();
  },
};
</script>

<style></style>
